import { useCallback } from 'react';

import type { CollapseState } from '@/features/AskSyncly/types/constants';
import type { FeedbackPeakAnalysisOptions } from '@/features/Feedback/components/FeedbackListModal/peak-analysis';
import type { FeedbackBlockListModalOptions } from '@/features/Feedback/components/FeedbackListModal/types';
import service from '@/services';
import useDetailModalStore, {
  DETAIL_MODAL_TYPE,
} from '@/stores/pure/DetailModalStore';
import { GPT_DOMAIN } from '@/types/gptConst';

const useInsightExplorerFeedbackListModal = () => {
  const setNewModal = useDetailModalStore((state) => state.setNewModal);
  const openInsightExplorerFeedbackListModal = useCallback(
    (params: {
      filter?: StructuredFilter;
      peakAnalysis?: FeedbackPeakAnalysisOptions;
      socketInfo?: {
        initialState?: CollapseState;
        initialPrompt?: string;
      };
    }) => {
      const { filter, peakAnalysis, socketInfo } = params;
      const uniqKey = JSON.stringify(filter);

      setNewModal<FeedbackBlockListModalOptions>({
        alias: uniqKey,
        type: DETAIL_MODAL_TYPE.FEEDBACK_BLOCK_LIST,
        idx: 0,
        keys: [uniqKey],
        options: {
          queryKeys: [uniqKey],
          title: 'Feedback list',
          domain: 'feedback-blocks',
          peakAnalysis,
          fetcher: async (
            sortStatus: NotNullableSortStatusT,
            pageParam?: null | string,
          ) => {
            const res = await service.feedback.fetchFeedbackBlockList({
              query: {
                sortby: sortStatus.sortBy,
                order: sortStatus.orderStatus,
                direction: 'next',
                cursor: pageParam || undefined,
              },
              payload: filter || {},
            });
            const PAGE_SIZE = 50;
            return {
              count: res.count,
              list: res.feedbacks || [],
              paginate_token: res.feedbacks?.[PAGE_SIZE]?.alias,
            };
          },
          socketInfo: {
            domain: GPT_DOMAIN.INSIGHT_EXPLORER,
            insight_explorer: filter,
            initialState: socketInfo?.initialState,
            initialPrompt: socketInfo?.initialPrompt,
          },
        },
      });
    },
    [setNewModal],
  );

  return openInsightExplorerFeedbackListModal;
};

export default useInsightExplorerFeedbackListModal;
